import React, { FC } from 'react';
import { Jumbotron, Container, Col, Row, Button } from 'react-bootstrap';
import { useUI } from '../../providers/ui/UIProvider';
import { toast } from 'react-toastify';

const ipsum = `Lorem ipsum dolor sit amet, consectetur adipiscing elit, sed do eiusmod tempor incididunt ut labore et dolore magna aliqua. Ut enim ad minim veniam, quis nostrud exercitation ullamco laboris nisi ut aliquip ex ea commodo consequat. Duis aute irure dolor in reprehenderit in voluptate velit esse cillum dolore eu fugiat nulla pariatur. Excepteur sint occaecat cupidatat non proident, sunt in culpa qui officia deserunt mollit anim id est laborum.`;

export const DashboardPage: FC = () => {
  const { showLoader } = useUI();

  const handleShowLoader = () => {
    showLoader(true);
    setTimeout(() => {
      showLoader(false);
    }, 3000);
    toast.success('Awesome button bushing, yo!');
  };

  return (
    <Container fluid>
      <Jumbotron>
        <h1>H1 Heading: Dashboard</h1>
        <h2>H2 Heading</h2>
        <h3>H3 Heading</h3>
        <h4>H4 Heading</h4>
        <h5>H5 Heading</h5>
        <Button variant="primary" onClick={handleShowLoader}>
          Show Loader
        </Button>
      </Jumbotron>
      <Row>
        <Col>
          <h2>Column One</h2>
          <p>{ipsum}</p>
        </Col>
        <Col>
          <h2>Column Two</h2>
          <p>{ipsum}</p>
        </Col>
        <Col>
          <h2>Column Three</h2>
          <p>{ipsum}</p>
        </Col>
      </Row>
    </Container>
  );
};
